import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { AutomationService } from '../../automation.service';
import { STATUS_CODES } from '../../../common/constants/defines';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'services-specification-names-edit',
    templateUrl: './services-specification-names-edit.component.html',
    styleUrls: ['./services-specification-names-edit.component.css']
})
export class ServicesSpecificationNamesEditComponent implements OnInit, OnDestroy {

    public serviceSpec: any = {
        name: '',
        type: ''
    };

    public flows: any[] = [];

    public formErrors: any[] = [];

    @Input() specNameId: string = null;

    public statusCodes = STATUS_CODES;

    public errorOverLay = null;

    private modifiedServices: string[] = [];

    private oldServices: string[] = [];

    public serviceSpecTypes: string[] = ['string', 'number', 'boolean', 'array-of-string', 'array-of-number', 'array-of-boolean'];

    public identifierTypes: string[] = ['uri', 'queryString', 'jsonPath', 'x-www-form-urlencoded'];

    constructor(private automationService: AutomationService,
        private activatedRoute: ActivatedRoute, private router: Router) { }

    ngOnDestroy(): void {

        this.automationService.registerSpinner.next(false);
    }

    public ngOnInit() {

        this.specNameId = this.activatedRoute.snapshot.params["id"];

        this.automationService.registerSpinner.next(true);

        this.automationService.findSpecName(this.specNameId)
            .subscribe((specName) => {

                this.serviceSpec.name = specName.name;
                this.serviceSpec.type = specName.type;

                this.flows = Object.keys(specName.flows).map((serviceName) => {

                    this.oldServices.push(serviceName);

                    return {
                        serviceName,
                        isMain: specName.flows[serviceName].isMain,
                        isActive: specName.flows[serviceName].isActive,
                        jsonPaths: specName.flows[serviceName].jsonPaths,
                        defaultStub: specName.flows[serviceName].defaultStub
                    }
                });

                this.automationService.registerSpinner.next(false);
            }, (error) => {
                this.automationService.registerSpinner.next(false);
                alert(error);
            });
    }

    public removeFlow(index: number) {

        this.handleServiceChange(this.flows[index].serviceName);

        this.flows.splice(index, 1);
    }
    public addDefaultStub(flow) {

        flow.defaultStub = {
            name: '',
            respCode: ''
        };
    }

    public removeDefaultStub(flow) {

        flow.defaultStub = null;

        this.handleServiceChange(flow.serviceName);
    }

    public addJsonPath(flow) {

        flow.jsonPaths = flow.jsonPaths ? flow.jsonPaths : [];

        flow.jsonPaths.push({
            path: '',
            propName: '',
            forIdentifiers: false,
            identifierType: ''
        });
    }

    public removeJsonPath(flow, index: number) {

        flow.jsonPaths.splice(index, 1);

        this.handleServiceChange(flow.serviceName);
    }

    public submit() {

        const changes = [];

        this.automationService.registerSpinner.next(true);

        this.flows = this.flows.map((flow) => {

            flow.serviceName = flow.serviceName.trim();

            if (Array.isArray(flow.jsonPaths)) {

                flow.jsonPaths.map((jsonpath) => {

                    if (jsonpath.forIdentifiers) {

                        jsonpath.path = `$.${jsonpath.propName.trim()}`;

                        jsonpath.identifierJsonPath = jsonpath.identifierJsonPath ? jsonpath.identifierJsonPath.trim() : undefined;

                        if (jsonpath.identifierType !== 'jsonPath') {

                            delete jsonpath.bodyJsonPath;
                        }
                    } else {

                        delete jsonpath.identifierJsonPath;

                        delete jsonpath.identifierType;
                    }

                    return jsonpath;
                });
            }

            if (flow.defaultStub && flow.defaultStub.name) {

                flow.isMain = true;
            }

            return flow;
        });

        this.modifiedServices.forEach((modifiedService) => {

            const index = this.flows.findIndex((flow) => flow.serviceName === modifiedService);

            if (index >= 0) {

                changes.push({
                    status: 'update',
                    serviceName: modifiedService,
                    flow: this.flows[index]
                });
            } else if (index === -1) {

                changes.push({
                    status: 'deleted',
                    serviceName: modifiedService
                });
            }
        });

        this.flows.forEach((flow) => {

            const index = this.oldServices.findIndex((oldService) => flow.serviceName === oldService);

            if (index === -1) {

                changes.push({
                    status: 'new',
                    serviceName: flow.serviceName,
                    flow
                });
            }
        });

        this.automationService.updateSpecName(this.specNameId, {
            changes,
            name: this.serviceSpec.name,
            type: this.serviceSpec.type
        }).subscribe(() => {

            this.automationService.registerSpinner.next(false);

            this.router.navigate(['/automation']);
        }, (error) => {
            this.automationService.registerSpinner.next(false);
                if (error && error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }
        });

    }

    public isNotValidFlows() {

        let isNotValid = false;

        this.flows.forEach(flow => {

            isNotValid = isNotValid || ((!flow.jsonPaths || !flow.jsonPaths.length) && (!flow.defaultStub));
        });

        return isNotValid;
    }

    public addFlow() {

        this.flows.push({
            serviceName: '',
            isMain: false,
            isActive: true,
            jsonPaths: [],
            defaultStub: null
        });
    }

    closeOverLay() {

        this.errorOverLay = null;
    }

    handleServiceChange(serviceName: string) {

        if (this.oldServices.indexOf(serviceName) >= 0 && this.modifiedServices.indexOf(serviceName) === -1) {

            this.modifiedServices.push(serviceName);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/services-specification-names/edit/services-specification-names-edit.component.ts